<template>
	<h4 class="panel-title"><slot /></h4>
</template>
